import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { useMobileDevice } from '../../../../global/useMobile';
import { Cards, Details, Dot, DotIcon, Icon, LeftContent, RevokeIcon, TitleSection } from './styles';
import Button from '../../../../component/button';
import { BUTTON_TYPE, ICON_SIZE } from '../../../../global/constants';

interface Props {
  iconName: string;
  title: string;
  location?: string;
  lastSeen: string;
  onRevoke?: () => void;
}

const DeviceCard: React.FC<Props> = ({ iconName, lastSeen, title, location, onRevoke }) => {
  const mobile = useMobileDevice();

  return (
    <Cards>
      <LeftContent>
        <Icon>
          <SVGIcon
            name={iconName}
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
        </Icon>
        <TitleSection>
          <h2>{title}</h2>
          <Details>
            {location && (
              <>
                <p>{location}</p>
                <DotIcon>
                  <Dot />
                </DotIcon>
              </>
            )}
            <p>{lastSeen}</p>
          </Details>
        </TitleSection>
      </LeftContent>
      {!mobile ? (
        <Button
          title='Revoke'
          variant={BUTTON_TYPE.SECONDARY}
          size='small'
          onClick={onRevoke}
          className='revoke-button'
        />
      ) : (
        <RevokeIcon role='button' onClick={onRevoke}>
          <SVGIcon
            name='exit-icon'
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-secondary)'
          />
        </RevokeIcon>
      )}
    </Cards>
  );
};

export default DeviceCard;
